<template>
  <label class="input-label input-in-row" for="textstamp-name">
    <span>{{ label || "Text" }}</span>
    <input
      class="input-label slate-bold"
      type="text"
      id="textstamp-name"
      @input="(e) => emitTextStampValue(e.target.value)"
      :value="textValue"
    />
  </label>
</template>

<script>
export default {
  name: "AddTextStampInput",
  props: ["textValue", "label"],
  methods: {
    emitTextStampValue(value) {
      this.$emit("changeTextValue", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-label {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  width: 100%;
  &.input-in-row {
    width: 40%;
  }

  span,
  p {
    margin-bottom: 0.5rem;
  }

  input {
    width: 100%;
    padding: 0.5rem 0.75rem;
    background: white;
    border: 1px solid $grey-light;
    border-radius: 6px;
    height: 3rem;
  }

  @media screen and (max-width: 768px) {
    width: 100% !important;
  }
}
</style>
